<mat-drawer-container style="height: 100%">
  <mat-drawer-content style="background: white">
    <h3>ワクチン摂取実施内容</h3>
    <div class="left-pane">
      <table class="event-list">
        <thead>
        <tr>
          <th>予定日</th>
          <th>日齢</th>
          <th>ワクチン名</th>
          <th>株</th>
          <th>メーカー</th>
          <th>投与方法</th>
          <th>ドース</th>
          <th>対象のロット</th>
        </tr>
        </thead>
        <tbody *ngIf="selectedMeisais && selectedMeisais.length > 0">
        <tr *ngFor="let vaccine of selectedMeisais;let vaccineIndex = index;">
          <td>{{vaccine?.yoteiDate}}</td>
          <td>{{vaccine.yoteiNichirei}}</td>
          <td>{{vaccine.vaccineName}}</td>
          <td>{{vaccine.vaccineKabu}}</td>
          <td>{{vaccine.maker}}</td>
          <td>{{vaccine.touyoHouhou}}</td>
          <td>{{vaccine.dose}}</td>
          <td>{{vaccine.taishouLotName}}</td>
        </tr>
        </tbody>
      </table>
      <br>
      <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-slide-toggle style="margin-left: 20px;" [(ngModel)]="editEvent">予定日を編集する</mat-slide-toggle>
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer style="width: 40%"opened position="end" mode="side">
    <div class="right-pane">
      <form #jisshiForm="ngForm" *ngIf="!editEvent">
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field appearance="legacy" style="padding-bottom: 10px;" class="width-195">
            <mat-label>実施日</mat-label>
            <input matInput [matDatepicker]="jisshiDatePicker" [(ngModel)]="inputForm.jisshiDate" name="jisshiDate" readonly
                   (click)="jisshiDatePicker.open()" (dateChange)="eventService.updateJisshiNichirei2(inputForm, edukeDate)">
            <mat-datepicker-toggle matSuffix [for]="jisshiDatePicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #jisshiDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field class="width-195">
            <mat-label>
              ロット番号
            </mat-label>
            <input matInput placeholder="ロット番号" required
                   name="vaccineLotNumber" [(ngModel)]="inputForm.vaccineLotNumber">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field class="width-195">
            <mat-label>
              有効期限
            </mat-label>
            <input matInput placeholder="有効期限" required
                   name="yuukouKigen" [(ngModel)]="inputForm.yuukouKigen">
          </mat-form-field>
        </div>
<!--        <div fxLayout="row wrap" fxLayoutGap="10px">-->
<!--          <mat-form-field appearance="legacy" style="padding-bottom: 10px">-->
<!--            <mat-label>投与月日</mat-label>-->
<!--            <input matInput [matDatepicker]="jisshiDatePicker" [(ngModel)]="inputForm.jisshiDate" name="jisshiDate"-->
<!--                   (click)="jisshiDatePicker.open()" (dateChange)="updateJisshiNichirei()">-->
<!--            <mat-datepicker-toggle matSuffix [for]="jisshiDatePicker"></mat-datepicker-toggle>-->
<!--            <mat-datepicker touchUi #jisshiDatePicker disabled="false"></mat-datepicker>-->
<!--          </mat-form-field>-->
<!--        </div>-->
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field class="width-195">
            <mat-label>
              投与日齢
            </mat-label>
            <input matInput placeholder="投与日齢" required disabled
                   name="jisshiNichirei" [(ngModel)]="inputForm.jisshiNichirei">
          </mat-form-field>
        </div>
<!--        <div fxLayout="row wrap" fxLayoutGap="10px">-->
<!--          <ng-select class="width-195"-->
<!--                     [items]="hinaHealth"-->
<!--                     bindLabel="name"-->
<!--                     bindValue="value"-->
<!--                     placeholder="鶏の健康状態 *"-->
<!--                     [closeOnSelect]="true"-->
<!--                     [multiple]="false"-->
<!--                     [required]="true"-->
<!--                     [(ngModel)]="inputForm.hinaHealth"-->
<!--                     name="hinaHealth"></ng-select>-->
<!--        </div>-->
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <ng-select class="width-195"
                     [items]="touyoHouhous"
                     bindLabel="name"
                     bindValue="name"
                     placeholder="投与方法 *"
                     disabled="true"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [required]="true"
                     [(ngModel)]="inputForm.touyoHouhou"
                     name="touyoHouhou"></ng-select>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px"
             *ngIf="inputForm.touyoHouhou === '飲水'
                    || inputForm.touyoHouhou === '散霧'">
          <mat-form-field class="width-195">
            <mat-label>
              溶解液は何か
            </mat-label>
            <input matInput placeholder="溶解液は何か" required
                   name="youkaiEki" [(ngModel)]="inputForm.youkaiEki">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px"
             *ngIf="inputForm.touyoHouhou === '飲水'">
          <mat-form-field class="width-195">
            <mat-label>
              断水時間
            </mat-label>
            <input matInput placeholder="断水時間" required
                   name="dansuiHour" [(ngModel)]="inputForm.dansuiHour">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px"
             *ngIf="inputForm.touyoHouhou === '飲水'
                    || inputForm.touyoHouhou === '散霧'">
          <mat-form-field class="width-195">
            <mat-label>
              溶解後の投与時間
            </mat-label>
            <input matInput placeholder="溶解後の投与時間" required
                   name="youkaiGoJikan" [(ngModel)]="inputForm.youkaiGoJikan">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px"
             *ngIf="inputForm.touyoHouhou === '飲水'
                    || inputForm.touyoHouhou === '散霧'">
          <mat-form-field class="width-195">
            <mat-label>
              溶解量
            </mat-label>
            <input matInput placeholder="溶解量" required
                   name="youkaiRyou" [(ngModel)]="inputForm.youkaiRyou">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="inputForm.touyoHouhou === '散霧'">
          <ng-select class="width-195"
                     [items]="maruBatsu"
                     bindLabel="name"
                     bindValue="value"
                     placeholder="ニューコンの洗浄 *"
                     appendTo="body"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [required]="true"
                     [(ngModel)]="inputForm.isWashedNyuukon"
                     name="isWashedNyuukon"></ng-select>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px"
             *ngIf="inputForm.touyoHouhou === '点眼'
                    || inputForm.touyoHouhou === '穿刺'
                    || inputForm.touyoHouhou === '筋注'
                    || inputForm.touyoHouhou === '皮下注'">
          <mat-form-field class="width-195">
            <mat-label>
              摂取部位
            </mat-label>
            <input matInput placeholder="摂取部位"
                   name="sesshuBui" [(ngModel)]="inputForm.sesshuBui">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px"
             *ngIf="inputForm.touyoHouhou === '穿刺'">
          <ng-select class="width-195"
                     [items]="maruBatsu"
                     bindLabel="name"
                     bindValue="value"
                     placeholder="発痘の確認 *"
                     appendTo="body"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [required]="true"
                     [(ngModel)]="inputForm.isHattou"
                     name="isHattou"></ng-select>
        </div>
<!--        <div fxLayout="row wrap" fxLayoutGap="10px"-->
<!--             *ngIf="inputForm.touyoHouhou === '飲水'-->
<!--                    || inputForm.touyoHouhou === '点眼'-->
<!--                    || inputForm.touyoHouhou === '散霧'">-->
<!--          <ng-select class="width-195"-->
<!--                     [items]="maruBatsu"-->
<!--                     bindLabel="name"-->
<!--                     bindValue="value"-->
<!--                     placeholder="溶解量は適切か *"-->
<!--                     [closeOnSelect]="true"-->
<!--                     [multiple]="false"-->
<!--                     [required]="true"-->
<!--                     [(ngModel)]="inputForm.isValidYoukaiRyou"-->
<!--                     name="isValidYoukaiRyou"></ng-select>-->
<!--        </div>-->
<!--        <div fxLayout="row wrap" fxLayoutGap="10px"-->
<!--             *ngIf="inputForm.touyoHouhou === '筋注'-->
<!--              || inputForm.touyoHouhou === '皮下注'">-->
<!--          <mat-form-field class="width-195">-->
<!--            <mat-label>-->
<!--              接種針の交換-->
<!--            </mat-label>-->
<!--            <input matInput placeholder="接種針の交換" required-->
<!--                   name="changeNeedleFrequency" [(ngModel)]="inputForm.changeNeedleFrequency">-->
<!--            <ng-select class="width-195"-->
<!--                       [items]="maruBatsu"-->
<!--                       bindLabel="name"-->
<!--                       bindValue="value"-->
<!--                       placeholder="接種針の交換 *"-->
<!--                       [closeOnSelect]="true"-->
<!--                       [multiple]="false"-->
<!--                       [required]="true"-->
<!--                       [(ngModel)]="inputForm.changeNeedleFrequency"-->
<!--                       name="changeNeedleFrequency"></ng-select>-->
<!--          </mat-form-field>-->
<!--        </div>-->
        <div fxLayout="row wrap" fxLayoutGap="10px"
             *ngIf="inputForm.touyoHouhou === '筋注'
              || inputForm.touyoHouhou === '皮下注'">
          <ng-select class="width-195"
                     [items]="maruBatsu"
                     bindLabel="name"
                     bindValue="value"
                     placeholder="接種針の交換 *"
                     appendTo="body"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [required]="true"
                     [(ngModel)]="inputForm.changeNeedleFrequency"
                     name="changeNeedleFrequency"></ng-select>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px"
             *ngIf="inputForm.touyoHouhou === '筋注'
              || inputForm.touyoHouhou === '皮下注'">
          <ng-select class="width-195"
                     [items]="maruBatsu"
                     bindLabel="name"
                     bindValue="value"
                     placeholder="ピスターの洗浄 *"
                     appendTo="body"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [required]="true"
                     [(ngModel)]="inputForm.isWashedPister"
                     name="isWashedPister"></ng-select>
        </div>
<!--        <div fxLayout="row wrap" fxLayoutGap="10px">-->
<!--          <ng-select class="width-195"-->
<!--                     [items]="umu"-->
<!--                     bindLabel="name"-->
<!--                     bindValue="value"-->
<!--                     placeholder="投与後のヒナの異常 *"-->
<!--                     [closeOnSelect]="true"-->
<!--                     [multiple]="false"-->
<!--                     [required]="true"-->
<!--                     [(ngModel)]="inputForm.checkHinaAbnormal"-->
<!--                     name="checkHinaAbnormal"></ng-select>-->
<!--        </div>-->
<!--        <div fxLayout="row wrap" fxLayoutGap="10px">-->
<!--          <ng-select class="width-195"-->
<!--                     [items]="weather"-->
<!--                     bindLabel="name"-->
<!--                     bindValue="value"-->
<!--                     placeholder="実施日の天候 *"-->
<!--                     [closeOnSelect]="true"-->
<!--                     [multiple]="false"-->
<!--                     [required]="true"-->
<!--                     [(ngModel)]="inputForm.weather"-->
<!--                     name="weather"></ng-select>-->
<!--        </div>-->
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field class="width-195">
            <mat-label>
              実施者
            </mat-label>
            <input matInput placeholder="実施者" required
                   name="jisshiSha" [(ngModel)]="inputForm.jisshiSha">
          </mat-form-field>
        </div>
        <br>
        <div fxLayout="row wrap" fxLayoutGap="12px" style="margin-bottom: 48px">
          <div [matTooltip]="commonService.getAlertTooltipMessage(jisshiForm)"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="primary" [disabled]="jisshiForm.invalid"
                    (click)="register();">登録
            </button>
          </div>
          <div [matTooltip]="!selectedMeisais[0].jisshiDate ? '実施内容が登録されていません。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="accent"
                    [disabled]="!selectedMeisais[0].jisshiDate"
                    (click)="undo();">取り消し
            </button>
          </div>
          <div [matTooltip]="selectedMeisais[0].jisshiDate ? '実施内容を取り消してから削除してください。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="warn"
                    [disabled]="!!selectedMeisais[0].jisshiDate"
                    (click)="delete();">削除
            </button>
          </div>
        </div>
      </form>
      <div *ngIf="editEvent">
        <app-event-edit [selectedMeisais]="selectedMeisais"></app-event-edit>
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
